import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Input, InputGroup, FormFeedback, InputGroupAddon, Col, Container, FormGroup, Label, Row, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    ALIBABA_URL
    // , API_URL
} from "../../config/Config";
import qs from "qs";
import axios from "axios";
import { toast } from "react-toastify";
import { ACCESS_TOKEN } from "../../redux/actions/setting";
import Checkbox from '@material-ui/core/Checkbox';
// import SaveLoader from "../../components/loader/SaveLoader";
import Steppers from "../../components/search/Steppers";

// import momentJalaali from 'moment-jalaali'
import * as moment from 'moment';
import 'moment-timezone';
// import SectionLoader from "../../components/loader/SectionLoader";
// import PriceFormatter from "../../components/misc/PriceFormatter";
import FlightItemDetail from "../../components/search/FlightItemDetail";
import PassengerForm from "../../components/search/PassengerForm";
import validator from "validator";
import { LangValidation } from "../../lang/en/validation";
// import Select from "react-select";
import { countryCode } from "../../redux/utils/countryCode";
import LoginModal from '../../components/user/LoginModal';
import { reviewTicket, goBackPassengers } from "../../redux/actions/ticket";
import SaveLoader from "../../components/loader/SaveLoader";




class TicketPassengers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: null,
            airports: [],
            passengers: [],
            showEmail: false,
            acceptTerms: false,
            showTerms: false,
            fields: {
                email: "",
                tel: "",
                mobile: "",
                isWhatsapp: false,
                telCode: "+98",
                mobileCode: "+98",
            },
            errors: {},
            country: [],
            pError: [],
            plzlogin: false,
            formvalid: false,
            agree_terms: false,
        }

    }
    async componentDidMount() {

        try {
            const { ticket } = this.props;
            let passenger_no = parseInt(ticket.adultNo, 10) + parseInt(ticket.childNo, 10) + parseInt(ticket.infantNo, 10);
            let passengers = [];
            let pError = [];
            for (let i = 0; i < passenger_no; i++) {
                let type = 1;
                if (i < parseInt(ticket.adultNo, 10)) {
                    type = 1;
                } else if ((parseInt(ticket.adultNo, 10) <= i) && (i < (parseInt(ticket.adultNo, 10) + parseInt(ticket.childNo, 10)))) {
                    type = 2;
                } else {
                    type = 3;
                }
                passengers.push({
                    nationalId: null,
                    passportId: null,
                    passportExpire: null,
                    DocType: 4,//Passport = 1,NationalId = 4,
                    DocIssuedCountry: "IR",//country iso code
                    name: "",
                    family: "",
                    BirthDate: "",
                    Gender: 1,//Male = 1,Female = 2
                    PassengerType: type,//Adult = 1, Child = 2, Infant = 3
                    id: -1
                });
                pError.push({});

            }
            //get search result
            let is_authenticated = false;
            if ((this.props.user.firstName !== null) && (this.props.user.firstName !== null)) {
                is_authenticated = true;
            }
            let country = await countryCode.map(item => {
                return {
                    value: "+" + item.code,
                    label: "+" + item.code
                };
            });

            this.setState({ is_authenticated, passengers, pError, country });
            const userlogin = JSON.parse(JSON.parse(localStorage["persist:root"]).user)
            if (localStorage.length !== 0 && userlogin.apiToken !== null) {
                this.setState({ plzlogin: true })
            } else {
                this.setState({ plzlogin: false })
            }

        } catch (e) {
            console.log(e);
            // window.location.replace("/");
        }

        // this.setState({loading:true});
    }
    render() {
        const { ticket } = this.props;
        const { fields, errors } = this.state;

        let goback;
        if (ticket['goback'] !== undefined) {

            goback = ticket.goback.goback;
        } else {
            goback = false;

        }

        const userislogin = this.props.user.apiToken

        return (
            <div className="pt-5 mt-5">
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Container className="min-height-500">
                    <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Passenger Information</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <Steppers active={1} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Ticket Information</h4>
                        </Col>
                    </Row>
                    <Row className='mt-2 md-5'>
                        <Col md='12' sm='12' >
                            <FlightItemDetail data={ticket.orgTicket} adultNo={ticket.adultNo} childNo={ticket.childNo} infantNo={ticket.infantNo} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3 mb-2">
                            <h4 className="text-uppercase green-text text-center">Passengers Information</h4>
                        </Col>
                    </Row>
                    <Row>
                        {/* {console.log(goback)} */}
                        {goback === true ?

                            <Col>
                                {/* {console.log(ticket.review_ticket.rev_passengers)} */}
                                {ticket.review_ticket.rev_passengers.map((item, index) =>
                                    <PassengerForm key={index} index={index}
                                        data={item} errors={this.state.pError[index]}
                                        set={this.handleSetPassenger.bind(this)}
                                        islogin={this.state.plzlogin}
                                        review={true}
                                    />
                                )}
                            </Col>
                            :
                            <Col >
                                {this.state.passengers.map((item, index) =>
                                    <PassengerForm key={index} index={index}
                                        data={item} errors={this.state.pError[index]}
                                        set={this.handleSetPassenger.bind(this)}
                                        islogin={this.state.plzlogin}
                                        review={false}
                                    />
                                )}
                            </Col>
                        }

                        {/* <Col >
                            {this.state.passengers.map((item, index) =>
                                <PassengerForm key={index} index={index}
                                    data={item} errors={this.state.pError[index]}
                                    set={this.handleSetPassenger.bind(this)}
                                    islogin={this.state.plzlogin}
                                />
                            )}
                        </Col> */}
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3 mb-2">
                            <h4 className="text-uppercase green-text text-center">Contact Information</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="white mb-3 w-100 flight-item padding-for-cart">
                                <CardBody>
                                    <Row>
                                        <Col >
                                            {userislogin === null &&
                                                <FormGroup check className="ml-0 pl-0">
                                                    <Label check>
                                                        <Checkbox
                                                            color="primary"
                                                            onChange={() => this.setState({ showEmail: !this.state.showEmail })}
                                                            checked={this.state.showEmail}
                                                            className='whithout-check-box'
                                                        />
                                                        <div className="login-Modal-p" ><span className='sign-in-span'> Continue without Sign up Or </span><LoginModal /></div>
                                                    </Label>
                                                </FormGroup>
                                            }

                                        </Col>
                                    </Row>
                                    {this.state.showEmail ?
                                        <Row>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Email</Label>
                                                    <Input
                                                        invalid={("email" in errors)}
                                                        name="email"
                                                        type="text"
                                                        placeholder="Email"
                                                        value={fields.email}
                                                        onChange={this.handleChange.bind(this)}
                                                    />
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Telephone</Label>
                                                    <InputGroup>
                                                        <InputGroupAddon addonType="prepend">
                                                            <Input

                                                                type="select"
                                                                name="telCode"
                                                                placeholder="Tel"
                                                                value={fields.telCode}
                                                                onChange={this.handleChange.bind(this)}>
                                                                {this.state.country.map((item, index) =>
                                                                    <option key={index} value={item.value}>{item.label}</option>
                                                                )}
                                                            </Input>
                                                        </InputGroupAddon>
                                                        <Input
                                                            invalid={("tel" in errors)}
                                                            name="tel"
                                                            type="text"
                                                            placeholder="Tel"
                                                            value={fields.tel}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                    </InputGroup>
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Mobile</Label>
                                                    <InputGroup>
                                                        <InputGroupAddon addonType="prepend">
                                                            <Input

                                                                type="select"
                                                                name="mobileCode"
                                                                placeholder="code"
                                                                value={fields.mobileCode}
                                                                onChange={this.handleChange.bind(this)}>
                                                                {this.state.country.map((item, index) =>
                                                                    <option key={index} value={item.value}>{item.label}</option>
                                                                )}
                                                            </Input>
                                                        </InputGroupAddon>
                                                        <Input
                                                            invalid={("mobile" in errors)}
                                                            name="mobile"
                                                            type="text"
                                                            placeholder="Mobile"
                                                            value={fields.mobile}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                    </InputGroup>
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup check className="ml-0 pl-0 mt-4">
                                                    <Label check>
                                                        <Checkbox
                                                            color="primary"
                                                        // onChange={()=>this.setState({ fields['isWhatsapp']:!this.state.isWhatsapp})}
                                                        // checked={this.state.fields.isWhatsapp}
                                                        />
                                                        <small>I have Whatsapp on mobile phone.</small>
                                                    </Label>
                                                </FormGroup>
                                            </Col>

                                        </Row> : ""}

                                    <Row>
                                        <Col >
                                            <FormGroup check className="ml-0 pl-0">
                                                <Label check>
                                                    <Checkbox
                                                        color="primary"
                                                        onChange={() => this.setState({ acceptTerms: !this.state.acceptTerms })}
                                                        checked={this.state.acceptTerms}
                                                    />
                                                    I read and accept site and ticket <Button color="link" onClick={() => this.setState({ showTerms: !this.state.showTerms })}>term and conditions.</Button>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {this.state.showTerms ?
                                        <Row>
                                            <Col >
                                                <p className="text-justify">
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                                </p>
                                            </Col>
                                        </Row> : ""}
                                    <Row>
                                        <Col >
                                            <Button color="primary" size="lg" block className="mb-4 mt-4 btn-green" onClick={this.handleClick.bind(this)}>
                                                Continue Booking
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                {/* {setTimeout(window.location.reload(), 60000)} */}
            </div>
        );
    }

    withoutSignValidate(e) {
        let result = true
        let fields = this.state.fields;
        let errors = {};

        if (validator.isEmpty(fields['email'])) {
            result = false;
            errors["email"] = LangValidation.required;
        } else if (!validator.isEmail(fields['email'])) {
            result = false;
            errors["email"] = LangValidation.email;
        }
        if (validator.isEmpty(fields['mobile'])) {
            result = false;
            errors["mobile"] = LangValidation.required;
        }
        this.setState({
            fields, errors
        });
        // console.log('3' + result)
        return result;
    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'email':
                if (validator.isEmpty(fields.email)) {
                    errors["email"] = LangValidation.required;
                } else if (!validator.isEmail(fields.email)) {
                    errors["email"] = LangValidation.email;
                }
                break;
            case 'mobile':
                if (validator.isEmpty(fields.mobile)) {
                    errors["mobile"] = LangValidation.required;
                }
                break;
            default:

        }
        this.setState({
            fields, errors
        });
        // console.log(this.state.fields)
    }

    async handleSetPassenger(index, passenger) {
        // console.log(passenger)
        let newPassengers = this.state.passengers;
        newPassengers[index] = passenger;
        this.setState({
            passengers: newPassengers
        });
    }

    async handleCheckPassengers(event) {
        event.preventDefault();

        if (this.state.showEmail === true) {
            let checkpassenger = await this.handlePassengerValidation((valid) => {
                if (valid === true) {
                    console.log(valid)
                    return true;
                } else {
                    return false;
                }
            });
            let checkemail = this.withoutSignValidate((valid) => {
                if (valid) {
                    console.log("email valid");
                    return true;
                } else {
                    return false;
                }
            });
            if (checkpassenger && checkemail) {
                this.setState({ formIsValid: true });
            } else {
                this.setState({ formIsValid: false });
            }

        } else if (this.state.plzlogin) {
            this.handlePassengerValidation((valid) => {
                if (valid) {
                    this.setState({ formIsValid: true });
                    console.log("all valid");

                    return true;
                } else {
                    return false;
                }
            });
        } else {
            alert('Sign in or Continue without Sign up')
        }

    }

    async handleClick(event) {
        event.preventDefault();
        //check contact form
        if (this.state.acceptTerms) {
            await this.handleCheckPassengers(event);
            // console.log(this.state.formIsValid)
            if (this.state.formIsValid === true) {

                const local = JSON.parse(localStorage["persist:root"]);
                const ticket = JSON.parse(local.ticket)
                // const user = JSON.parse(local.user)
                moment.defaultFormat = "YYYY-MM-DD HH:mm:ss";
                let arrivalDate = moment(ticket.ticket.arrivalDate).format("YYYY-MM-DD HH:mm:ss")
                let departureDate = moment(ticket.ticket.departureDate).format("YYYY-MM-DD HH:mm:ss")

                let startfilght = moment(ticket.ticket.arrivalDate).format("DD/MM/YYYY HH:mm:ss")
                var endflight = moment(ticket.ticket.departureDate).format("DD/MM/YYYY HH:mm:ss")

                let flightDuration = moment.utc(moment(startfilght, "DD/MM/YYYY HH:mm:ss").diff(moment(endflight, "DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
                const userislogin = this.props.user.apiToken

                this.setState({
                    loading: true
                })

                if (userislogin === null) {

                    const data = {
                        "adultNo": ticket.adultNo,
                        "childNo": ticket.childNo,
                        "infantNo": ticket.infantNo,
                        "user":
                        {
                            "email": this.state.fields.email,
                            "cell_phone": this.state.fields.mobile,
                            "tel": this.state.fields.telCode + this.state.fields.tel,
                            "whatsapp": (this.state.fields.isWhatsapp === false ? null : this.state.fields.mobile)
                        },
                        "ticket":
                        {
                            "adultFare": ticket.ticket.adultFare,
                            "adultFareT": ticket.ticket.adultFareT,
                            "airEquipName": ticket.ticket.airEquipName,
                            "airEquipType": ticket.ticket.airEquipType,
                            "airItineraryRph": ticket.ticket.airItineraryRph,
                            "airLine": ticket.ticket.airLine,
                            "arrivalAirport": ticket.ticket.arrivalAirport,
                            "arrivalDate": arrivalDate,
                            "availableSeat": ticket.ticket.availableSeat,
                            "baseFare": ticket.ticket.baseFare,
                            "bookingClassAvail": ticket.ticket.bookingClassAvail,
                            "childFare": ticket.ticket.childFare,
                            "childFareT": ticket.ticket.childFareT,
                            "departureAirport": ticket.ticket.departureAirport,
                            "departureDate": departureDate,
                            "flightDuration": flightDuration,
                            "flightNumber": ticket.ticket.flightNumber,
                            "infantFare": ticket.ticket.infantFare,
                            "infantFareT": ticket.ticket.infantFareT,
                            "isChartered": ticket.ticket.isChartered,
                            "isDomestic": ticket.ticket.isDomestic,
                            "isRefundable": ticket.ticket.isRefundable,
                            "totalFare": ticket.ticket.totalFare,
                            "orgTicket": qs.stringify(ticket.ticket.orgTicket)
                        },
                        "passengers": this.state.passengers,
                        "api_token": null
                    }
                    const rev_passengers = this.state.passengers;
                    this.props.reviewTicket(data, rev_passengers);
                    this.props.goBackPassengers(false);
                    window.location.replace('/ticket-review');

                    // const options = {
                    //     method: 'POST',
                    //     headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    //     data: qs.stringify(data),
                    //     url: API_URL + 'airplane-ticket-register',
                    // };
                    // let response = await axios(options);
                    // console.log(response);

                    // if (response.status < 200 || response.status > 300) {
                    //     const error = new Error(response.statusText);
                    //     error.response = response;
                    //     console.log(error);
                    //     toast.error('An error occurred while receiving information from the server.', {
                    //         autoClose: 3000,
                    //         position: toast.POSITION.TOP_RIGHT,
                    //         rtl: false
                    //     });
                    // } else {
                    //     this.setState({
                    //         loading: false
                    //     })
                    //     // console.log(response);
                    //     const rev_passengers = this.state.passengers;
                    //     const data = response.data.data;
                    //     // console.log(data)
                    //     this.props.reviewTicket(data, rev_passengers);
                    //     // console.log('next-page');
                    // window.location.replace('/ticket-review');
                    // }

                } else {
                    console.log('login');
                    // this.setState({
                    //     loading: false
                    // })
                    const api_token = localStorage.getItem('api_token');
                    const data = {
                        "adultNo": ticket.adultNo,
                        "childNo": ticket.childNo,
                        "infantNo": ticket.infantNo,
                        "ticket":
                        {
                            "adultFare": ticket.ticket.adultFare,
                            "adultFareT": ticket.ticket.adultFareT,
                            "airEquipName": ticket.ticket.airEquipName,
                            "airEquipType": ticket.ticket.airEquipType,
                            "airItineraryRph": ticket.ticket.airItineraryRph,
                            "airLine": ticket.ticket.airLine,
                            "arrivalAirport": ticket.ticket.arrivalAirport,
                            "arrivalDate": arrivalDate,
                            "availableSeat": ticket.ticket.availableSeat,
                            "baseFare": ticket.ticket.baseFare,
                            "bookingClassAvail": ticket.ticket.bookingClassAvail,
                            "childFare": ticket.ticket.childFare,
                            "childFareT": ticket.ticket.childFareT,
                            "departureAirport": ticket.ticket.departureAirport,
                            "departureDate": departureDate,
                            "flightDuration": flightDuration,
                            "flightNumber": ticket.ticket.flightNumber,
                            "infantFare": ticket.ticket.infantFare,
                            "infantFareT": ticket.ticket.infantFareT,
                            "isChartered": ticket.ticket.isChartered,
                            "isDomestic": ticket.ticket.isDomestic,
                            "isRefundable": ticket.ticket.isRefundable,
                            "totalFare": ticket.ticket.totalFare,
                            "orgTicket": qs.stringify(ticket.ticket.orgTicket)
                        },
                        "passengers": this.state.passengers,
                        "api_token": api_token

                    }
                    console.log(api_token);
                    console.log(data);
                    const rev_passengers = this.state.passengers;
                    this.props.reviewTicket(data, rev_passengers);
                    this.props.goBackPassengers(false);
                    window.location.replace('/ticket-review');
                    // const options = {
                    //     method: 'POST',
                    //     headers: { 'content-type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + api_token },
                    //     data: qs.stringify(data),
                    //     url: API_URL + 'airplane-ticket-register'
                    // };
                    // let response = axios(options);
                    // console.log(response);
                    // if (response.status < 200 || response.status > 300) {
                    //     const error = new Error(response.statusText);
                    //     error.response = response;
                    //     console.log(error);
                    //     toast.error('An error occurred while receiving information from the server.', {
                    //         autoClose: 3000,
                    //         position: toast.POSITION.TOP_RIGHT,
                    //         rtl: false
                    //     });
                    // } else {
                    //     this.setState({
                    //         loading: false
                    //     })
                    //     const rev_passengers = this.state.passengers;
                    //     this.props.reviewTicket(data, rev_passengers);
                    //     this.props.goBackPassengers(false);
                    //     window.location.replace('/ticket-review');
                    // }
                }
            } else {
                alert("Data your entered in not valid, please check again!")
            }

        } else {
            // let errors = {};
            // errors['terms'] = LangValidation.required;
            // this.setState({ errors });
            alert("Please accept our terms and conditions")
        }

    }



    handlePassengerValidation(callback) {
        const { passengers } = this.state;
        let newError = this.state.pError;
        let formIsValid = true;

        // console.log(passengers)

        for (let i = 0; i < passengers.length; i++) {
            let cPassenger = passengers[i];
            // console.log(cPassenger)
            let errors = newError[i];
            if (validator.isEmpty(cPassenger.name)) {
                formIsValid = false;
                errors["name"] = LangValidation.required;
            } else if (!validator.isLength(cPassenger.name, { min: 3, max: undefined })) {
                formIsValid = false;
                errors["name"] = LangValidation.min;
            }
            if (validator.isEmpty(cPassenger.family)) {
                formIsValid = false;
                errors["family"] = LangValidation.required;
            } else if (!validator.isLength(cPassenger.family, { min: 3, max: undefined })) {
                formIsValid = false;
                errors["family"] = LangValidation.min;
            }
            if (validator.isEmpty(cPassenger.BirthDate)) {
                formIsValid = false;
                errors["BirthDate"] = LangValidation.required;
            } else {
                // console.log(cPassenger.DocType)
                let passanger_age;

                const todayyear = moment().format('YYYY');
                const selectedyear = cPassenger.BirthDate.substring(0, 4)
                passanger_age = todayyear - selectedyear

                // momentJalaali
                // console.log(momentJalaali().format('jYYYY'))
                // console.log(cPassenger.BirthDate)
                // console.log(passanger_age)
                switch (cPassenger.PassengerType) {
                    case 1:
                        if (passanger_age < 12) {
                            formIsValid = false;
                            errors["BirthDate"] = LangValidation.adult_age;
                        }
                        break;
                    case 2:
                        if (passanger_age < 2) {
                            // console.log(passanger_age)
                            formIsValid = false;
                            errors["BirthDate"] = LangValidation.child_age;
                        }
                        if (passanger_age > 12) {
                            // console.log(passanger_age)
                            formIsValid = false;
                            errors["BirthDate"] = LangValidation.child_age;
                        }
                        break;
                    case 3:
                        console.log(cPassenger.DocIssuedCountry);
                        console.log(passanger_age);
                        if (passanger_age > 2) {
                            formIsValid = false;
                            errors["BirthDate"] = LangValidation.infant_age;
                        }
                        break;
                    default: formIsValid = true
                }
            }
            if (parseInt(cPassenger.DocType, 10) === 1) {
                //passport
                console.log(cPassenger.passportExpire);
                if (cPassenger.passportId === null) {
                    formIsValid = false;
                    errors["passportId"] = LangValidation.required;
                } else {
                    if (validator.isEmpty(cPassenger.passportId)) {
                        formIsValid = false;
                        errors["passportId"] = LangValidation.required;
                    }
                }
                if (cPassenger.passportExpire === null) {
                    formIsValid = false;
                    errors["passportExpire"] = LangValidation.required;
                } else {
                    if (validator.isEmpty(cPassenger.passportExpire)) {
                        formIsValid = false;
                        errors["passportExpire"] = LangValidation.required;
                    }
                }
                // errors["nationalId"] = null;
            } else {
                //national id
                if (cPassenger.nationalId === null) {
                    formIsValid = false;
                    errors["nationalId"] = LangValidation.required;
                } else {
                    if (validator.isEmpty(cPassenger.nationalId)) {
                        formIsValid = false;
                        errors["nationalId"] = null;
                    } else if (cPassenger.nationalId.length !== 10) {
                        formIsValid = false;
                        errors["nationalId"] = LangValidation.national_id;
                    }
                }
                // errors["passportId"] = null;
                // errors["passportExpire"] = null;
            }

            if (validator.isEmpty(cPassenger.DocIssuedCountry)) {
                formIsValid = false;
                errors["DocIssuedCountry"] = LangValidation.required;
            }
        }
        this.setState({ pError: newError });
        return callback(formIsValid)
    }

    async handleRequest() {
        this.setState({ loading: false });
        try {
            const { data } = this.state;
            let access_token = localStorage.getItem(ACCESS_TOKEN);

            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'X-ZUMO-AUTH': access_token,
                    'Content-Type': 'application/json',
                },
                data: qs.stringify(data),
                url: `${ALIBABA_URL}Available/Get`,
            };


            let response = await axios(options);
            // console.log(response)
            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error('An error occurred while receiving information from the server.', {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: false
                });
            } else {
                let data = response.data.data.pricedItineraries;
                let count = response.data.data.count;
                // console.log(data);
                this.setState({
                    flights: data,
                    flights_filterd: data,
                    flight_number: count
                })
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
            }
        }
        this.setState({ loading: true });
    };

}

const mapDispatchToProps = dispatch => {
    return {
        reviewTicket: (data, rph) => {
            dispatch(reviewTicket(data, rph))
        },
        goBackPassengers: (goback) => {
            dispatch(goBackPassengers(goback))
        }
    }
};


const mapStateToProps = (state) => {
    return {
        user: state.user,
        ticket: state.ticket,
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(TicketPassengers)



// WEBPACK FOOTER //
// ./src/containers/search/TicketPassengers.js